import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { AuthScreen } from './types';

interface AuthContextProps {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  screen: AuthScreen;
  setScreen: Dispatch<SetStateAction<AuthScreen>>;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Using useAppContext outside AppContextProvider is not allowed.');
  }
  return context;
}

function useAuthContextProviderVM() {
  const [email, setEmail] = useState('');
  const [screen, setScreen] = useState(AuthScreen.LOGIN);

  return useMemo(
    () => ({
      email,
      setEmail,
      screen,
      setScreen,
    }),
    [screen, email]
  );
}

export interface AppContextProviderProps {
  children: ReactNode;
}

export function AuthContextProvider({ children }: AppContextProviderProps) {
  const providerValue = useAuthContextProviderVM();
  return <AuthContext.Provider value={providerValue}>{children}</AuthContext.Provider>;
}
